import React from "react";
import BaseMessages from "../../sisu/messages/BaseMessages.sisu";
import NeoColumn from "../layout/NeoColumn.base";

const NeoMessages = React.forwardRef((props, ref) => {
  return (<NeoColumn col="12"><BaseMessages {...props} ref={ref} /></NeoColumn>);
})

export default NeoMessages;